<template>
  <div class="instrument-more">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
      <div class="content">
        <div style="color: #D2B08C;font-size: 56px">专注医疗级盆底修复</div>
        <div style="margin: 25px 0 15px;font-size: 28px">改善干涩松弛紧塑盆底肌</div>
<!--        <div class="buy-now" @click="goToBuy">-->
<!--          <img src="../../assets/image/cart.png"/>-->
<!--          立即购买-->
<!--        </div>-->
<!--        <div  style="color: #ffffff;font-size: 20px;display: flex;flex-direction: row;align-items: center">-->
<!--          <img src="../../assets/image/right.png" style="width: 24px; height: 24px;margin-right: 5px"/>-->
<!--          了解更多-->
<!--        </div>-->
      </div>
    </div>
    <div class="page2"  ref="page2" id="page2">
      <div class="sticky-wrapper" ref="page2Sticky">
        <div class="page-inner sticky-inner">
          <div class="content">
              <div :class="['tech-title',{'active': pageTwoIndex> 39}]">通过<span style="color: #D2B08C">1003</span>项国家行业<br/>
                技术检测标准
              </div>
              <div class="tech-data">
                <div v-for="(item,itemInd) in testData" :key="itemInd" :class="{'active': itemInd< 3? pageTwoIndex> 48: (pageTwoIndex> 49 && pageTwoPer> 0.3)}">
                  <div style="text-align: center">
                    <div class="num">{{item.num}}<span style="font-size: 24px;color: #090404;margin: 5px 0 0 3px">项</span></div>
                    <div>{{item.projectName}}</div>
                    <div v-if="item.projectName2">{{item.projectName2}}</div>
                  </div>
                </div>
              </div>
          </div>
          <div class="canvas-wrapper"  id="page2CanvasWrapper">
            <canvas id="page2Canvas"/>
          </div>
        </div>
      </div>
    </div>
    <div class="page3"  ref="page3" id="page3">
      <div class="title">专注医疗级盆底修复</div>
      <div class="sub-title">Elechcy生电联合科技</div>
      <div class="intro-wrapper">
        <div v-for="(item,itemInd) in repairData" :key="itemInd">
          <div class="intro-item">
            <img :src="item.img"/>
            <div>{{item.tit}}</div>
            <div class="sub-tit">{{item.subTit}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page4" ref="page4">
      <div class="sticky-wrapper" ref="page4Sticky">
        <div class="page-inner sticky-inner">
          <div class="inner-content">
            <div class="screen-box">
              <img src="../../assets/image/phone2.png"/>
              <div class="screens">
                  <div  :class="['screen-item',{'active': screenIndex === 0}]">
                    <img :src="require(`../../assets/image/p000.png`)"/>
                  </div>
                <div  :class="['screen-item',{'active': screenIndex === 1}]">
                  <img  :src="require(`../../assets/image/p001.png`)"/>
                </div>
                <div :class="['screen-item',{'active': screenIndex === 2}]">
                  <img :src="require(`../../assets/image/p002.png`)"/>
                </div>
                <div :class="['screen-item',{'active': screenIndex === 3}]">
                  <img :src="require(`../../assets/image/p003.png`)"/>
                </div>
              </div>
            </div>
            <div class="screen-words">
              <div :class="['words-box','show-0-words',{active: screenIndex === 0}]" :style="{opacity: screenIndex === 0? pageTwoPer: 0}">
                <p>THERAPEUTIC SCHEDULE</p>
                <div style="font-size: 46px;margin: 10px 0 15px;"><span style="color: #D2B08C">359个</span>诊疗方案</div>
                <p style="color: #7f7d7d">我们期望通过精准的使用体验满足更精细的<br/>盆底修复需求。</p>
                <p style="color: #7f7d7d">让每位使用者都能得到有效满意的治疗效果</p>
              </div>
              <div :class="['words-box','show-1-words',{active: screenIndex === 1}]" :style="{opacity: screenIndex === 1? pageTwoPer: 0}">
                <div style="font-size: 46px;margin: 10px 0 15px;">推荐治疗方案<span style="color: #D2B08C">5个</span></div>
                <p style="color: #7f7d7d">依据具体“盆底功能评估”结果智能推荐治疗方案</p>
              </div>
              <div :class="['words-box','show-2-words',{active: screenIndex === 2}]" :style="{opacity: screenIndex === 2? pageTwoPer: 0}">
                <div style="font-size: 46px;margin: 10px 0 15px;">标准治疗方案<span style="color: #D2B08C">65个</span></div>
                <p>盆底功能障碍预防和保养<span>20</span></p>
                <p>盆底功能障碍治疗<span>30</span></p>
                <p>治疗阴道松弛症,提升女性性功能<span>17</span></p>
              </div>
              <div :class="['words-box','show-3-words',{active: screenIndex === 3}]" :style="{opacity: screenIndex === 3? pageTwoPer: 0}">
                <div style="font-size: 46px;margin: 10px 0 15px;">专项盆底锻炼<span style="color: #D2B08C">251个</span></div>
                <p style="color: #7f7d7d">常规疗程后针对个性化需求指标做提升</p>
                <div class="inline-txt"><p class="left">混合机锻炼<span>92</span></p><p>二类肌锻炼<span>6</span></p></div>
                <div class="inline-txt"><p class="left">一类肌锻炼<span>71</span></p><p>紧致阴道<span>17</span></p></div>
                <div class="inline-txt"><p class="left">情景模拟<span>54</span></p><p>产后康复<span>5</span></p></div>
                <p>促进血液循环缓解肌肉疼痛 <span>6</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page5" ref="page5" id="page5">
      <div class="sticky-wrapper" ref="page5Sticky">
        <div class="page-inner sticky-inner">
          <div class="content">
            <div style="width: 500px">
              <div style="color: #323232;font-size: 56px;margin-bottom: 20px">创新四片式</div>
              <div style="color: #323232;font-size: 56px;margin-bottom: 20px">黄金镀金贴片</div>
              <div class="feature-wrapper">
                <div v-for="(item,itemInd) in featureData" :key="itemInd"
                 :class="['page5-txt',{'has-border': itemInd < featureData.length-1},{'active': page5ScrollPer> 0.1+itemInd*0.1}]">
                  <div class="title">{{item.tit}}</div>
                  <div>{{item.subTit}}</div>
                  <div class="intro">{{item.intro}}</div>
                </div>
              </div>
            </div>
            <div class="canvas-wrapper"  id="page5CanvasWrapper" style="left: 550px">
              <canvas id="page5Canvas"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";
const page2Img = new Image()
const page5Img = new Image()
export default {
  name: "InstrumentMore",
  components: {Footer, TopNav},
  data(){
    return {
      testData: [{num: 610,projectName:'电气安全检测'},{num: 73,projectName:'性能指标检测'},{num: 208,projectName:'软件测试检测'},
        {num: 18,projectName:'生物和电磁',projectName2:'兼容性检测'},{num: 93,projectName:'电气安全检测'},{num: 1,projectName:'无线电发射检测'}],
      repairData: [
        {img: require('../../assets/image/repair1.gif'),tit:'Ele-cosy 低频神经肌肉电刺激',subTit:'被动刺激 提升肌肉本体感知'},
        {img: require('../../assets/image/repair2.gif'),tit:'Chcy-precision 肌电生物反馈',subTit:'主动锻炼 精准有效'},
        {img: require('../../assets/image/repair3.gif'),tit:'Elechcy 生电科技联合',subTit:'主被动效率更高'},
      ],
      featureData: [{tit:'四贴片',subTit:'设计',intro:'修复更高效'},{tit:'全方位',subTit:'精准修复',intro:'持续低刺激温和舒适'},{tit:'强传导力',subTit:'',intro:'黄金镀金高稳定性'}],
      screenIndex: 0,
      matPer: 0.8,
      page5Canvas: null,
      page2Canvas: null,
      page5Offset: 0,
      page5Ctx: 0,
      lastScrollTop: 0,
      pageFiveIndex: 1, //图片命名由1开始
      page5ScrollPer: 0,
      time: 0,
      pageTwoIndex: 0, //图片命名由0开始
      page2Offset: 0,
      page2Ctx: 0,
      pageTwoPer: 1,
      isUp: true,
    }
  },
  mounted() {
    const st = document.documentElement.scrollTop || document.body.scrollTop
    if(st> 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    this.page2CanvasAniInit()
    this.page5CanvasAniInit()
    window.addEventListener('wheel', (event) => {
        this.isUp = event.deltaY > 0
    })
    window.addEventListener('scroll',(event) => {
      const st = document.documentElement.scrollTop || document.body.scrollTop
      const page2 = this.$refs.page2
      const page3 = this.$refs.page3
      const page4 = this.$refs.page4
      const page5 = this.$refs.page5
      if( page2 && st<page2.offsetTop/2) {
        this.pageTwoIndex = 0
        setTimeout(() => {
          this.page2Ctx.clearRect(0, 0, this.page2Canvas.width, this.page2Canvas.height)
        })
      }
      if(page2) {
        if( st >= page2.offsetTop && st< page3.offsetTop) {
          this.page2AniScroll(st)
        }
      }
      if(page4) {
        if( st<page4.offsetTop) {
          this.screenIndex = 0
        }
        if( st >= page4.offsetTop && st< page5.offsetTop) {
          this.phoneScreenScroll(st)
        }
      }
      if( st< this.page5Offset) {
        this.pageFiveIndex = 1
        this.renderPage5()
      }
      if( st >= this.page5Offset) {
        this.page5AniScroll(st)
      }
    },true)
  },
  methods: {
    phoneScreenScroll(st){
      requestAnimationFrame(() => {
        const page = this.$refs.page4
        const sticky = this.$refs.page4Sticky
        const per = (st-page.offsetTop)/sticky.clientHeight
        this.screenIndex = Math.min(3, Math.floor(per*1.5*4))
        this.pageTwoPer = Math.min(3.9, per*1.5*4) - this.screenIndex > 0.6? 1 : (Math.min(3.9, per*1.5*4) - this.screenIndex)
        if(!this.isUp && this.screenIndex === 0 && this.pageTwoIndex> 0.7) {
          this.pageTwoPer = 1
        }
      })
    },
    //修复仪
    page2CanvasAniInit () {
      this.page2Canvas = document.querySelector('#page2Canvas')
      const wrapper =  document.querySelector('#page2CanvasWrapper')
      const per = window.innerWidth < 1441 || window.devicePixelRatio>1 ? 0.8: 1
      this.page2Canvas.width = wrapper.clientWidth*per
      this.page2Canvas.height = wrapper.clientWidth*1.05*per
      this.page2Ctx = this.page2Canvas.getContext('2d')
      this.page2Offset = document.querySelector('#page2').offsetTop
      this.renderPage2()
    },
    renderPage2 (){
      page2Img.onload = () => {
        this.page2Ctx.clearRect(0, 0, this.page2Canvas.width, this.page2Canvas.height)
        this.page2Ctx.drawImage(page2Img, 0, 0, this.page2Canvas.width, this.page2Canvas.height)
      }
      page2Img.src = this.getTechPic(this.pageTwoIndex)
    },
    page2AniScroll(st) {
      const sticky = this.$refs.page2Sticky
      const per = (st-this.page2Offset)/sticky.clientHeight
      this.pageTwoIndex = Math.min(50, Math.ceil(per*5*51))
      this.pageTwoPer = per
      requestAnimationFrame(this.renderPage2)
    },
    getTechPic(pageTwoIndex){
      if(pageTwoIndex<10){
        return require(`../../assets/image/tech/1_000${pageTwoIndex}.jpg`)
      }else {
        return require(`../../assets/image/tech/1_00${pageTwoIndex}.jpg`)
      }
    },
    //电极头
    page5CanvasAniInit () {
      this.page5Canvas = document.querySelector('#page5Canvas')
      const wrapper =  document.querySelector('#page5CanvasWrapper')
      const per = window.innerWidth< 1441 || window.devicePixelRatio>1? 0.8:1
      this.page5Canvas.width = wrapper.clientWidth*per
      this.page5Canvas.height = wrapper.clientWidth*1.3*per
      this.page5Ctx = this.page5Canvas.getContext('2d')
      this.page5Offset = document.querySelector('#page5').offsetTop
      this.renderPage5()
    },
    renderPage5 (){
     page5Img.onload = () => {
        this.page5Ctx.clearRect(0, 0, this.page5Canvas.width, this.page5Canvas.height)
        this.page5Ctx.drawImage(page5Img, 0, 0, this.page5Canvas.width, this.page5Canvas.height)
      }
     page5Img.src = this.getInstruPic(this.pageFiveIndex)
    },
    page5AniScroll(st) {
      // if(this.lastScrollTop> st) {
      //   this.matPer = Math.round(this.matPer * 100) / 100>=0.8?(this.matPer/1.001): 0.8
      // } else{
      //   this.matPer = Math.round(this.matPer * 100) / 100 >=1.1? 1.1: this.matPer*1.004
      // }
      // this.lastScrollTop = st
      const sticky = this.$refs.page5Sticky
      const per = (st-this.page5Offset)/sticky.clientHeight
      this.page5ScrollPer = per
      this.pageFiveIndex = Math.min(41, Math.ceil(per*4*41))
      this.pageFiveIndex = this.pageFiveIndex< 1? 1: this.pageFiveIndex
      requestAnimationFrame(this.renderPage5)
    },
    getInstruPic(pageFiveIndex){
      if(pageFiveIndex<10){
        return require(`../../assets/image/intru/C4D000${pageFiveIndex}.jpg`)
      }else {
        return require(`../../assets/image/intru/C4D00${pageFiveIndex}.jpg`)
      }
    },
    goToBuy(){
      sessionStorage.setItem('activeNav', 'buy')
      this.$router.push('/buy')
    }
  }
}
</script>
<style lang="less"  scoped>
.instrument-more {
  height: 100%;
  font-size: 16px;
  .content {
    width: 55%;
    margin: 0 auto;
    padding-top: 22%;
    max-width: 1024px;
  }
  .sticky-inner{
    background-color: #ffffff;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .sticky-wrapper {
    position: relative;
    --fade-distance: 11vh;
    --is-visible-distance: 30vh;
  }
  .page1 {
    height: 100%;
    min-height: 900px;
    background: url("../../assets/image/intru1.jpg") no-repeat 0 0/100% 100%;
    .buy-now{
      color: #ffffff;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 17px;
      padding: 5px 0;
      width: 150px;
      justify-content: center;
      background: linear-gradient(to right,#DDC4A9,#D2B08C);
      flex: 0 0 auto;
      cursor: pointer;
      margin-top: 10px;
      img {
        margin-right: 8px;
      }
    }
  }
  .page2 {
    .sticky-wrapper::after{
      content: '';
      display: block;
      height: calc((var(--fade-distance) + var(--is-visible-distance) + var(--fade-distance))*1.3);
    }
    .sticky-inner {
      position: sticky;
      position: -webkit-sticky;
      background: #ebebeb;
      top: 0;
    }
    .content {
      padding-top: 12%;
      .tech-title{
        color: #323232;
        font-size: 56px;
        margin-bottom: 20px;
        opacity: 0;
      }
      .tech-title.active{
        opacity: 1;
        transition: all 300ms ease-in-out;
      }
      .tech-data {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 450px;
        >div {
          padding-right: 25px;
          flex-basis: 33.3%;
          box-sizing: border-box;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          opacity: 0;
          .num {
            font-size: 42px;
            color: #D2B08C;
          }
        }
      }
      .tech-data .active{
        opacity: 1;
        transition: all 500ms ease-in-out;
      }
    }
    .canvas-wrapper {
      position: absolute;
      width: 839px;
      left: 55%;
      transform: translate(-50%,0);
      z-index: -1;
      top: 0;
      background: #ebebeb;
      height: 100%;
      text-align: center;
    }
  }
  .page3 {
    background: #f5f5f5;
    height: 100%;
    min-height: 900px;
    text-align: center;
    .title {
      color: #323232;
      font-size: 56px;
      padding: 80px 0 10px;
    }
    .sub-title {
      color: #646464;
      font-size: 26px;
      margin: 5px 0 15px;
    }
    .intro-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: center;
      >div {
        padding: 18px;
        .intro-item {
          width: 326px;
          color: #323232;
          font-size: 24px;
          img {
            width: 316px;
            height: 396px;
            margin: 30px 0;
          }
          .sub-tit {
            font-size: 16px;
            margin-top: 12px;
          }
        }
      }
    }
  }
  .page4 {
    .sticky-wrapper::before{
      content: '';
      display: block;
      height: calc((var(--fade-distance) + var(--is-visible-distance) + var(--fade-distance))*3);
    }
    .sticky-inner {
      position: sticky;
      position: -webkit-sticky;
      bottom: 0;
      min-height: 100%;
      background-image: url("../../assets/image/intru3.jpg");
      .inner-content {
        display: flex;
        flex-direction: row;
        width: 1220px;
        margin: 0 auto;
        position: relative;
        height: 100%;
        .screen-box {
          width: 685px;
          height: 680px;
          position: absolute;
          bottom: 4%;
          left: -13px;
          img {
            width: 100%;
            height: 100%;
          }
          .screens {
            position: absolute;
            width: 203px;
            height: 438px;
            bottom: 103px;
            right: 121px;
            overflow: hidden;
            .screen-item {
              height: 100%;
              width: 100%;
              opacity: 0;
              border-radius: 30px;
              transition: all 500ms ease-in-out;
              position: absolute;
              top: 0;
              img {
                border-radius: 30px;
              }
            }
            .active {
              opacity: 1;
            }
          }
        }
        .screen-words {
          position: absolute;
          right: 0;
          height: 680px;
          bottom: 4%;
          font-size: 22px;
          width: 530px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          p {
            margin: 0;
            line-height: 35px;
            clear: both;
            color: #323232;
            span {
              float: right;
            }
          }
          .words-box {
            opacity: 0;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            will-change:  opacity;
            .inline-txt {
              p {
                display: inline-block;
                width: 175px;
              }
              .left {
                margin-right: 80px;
              }
            }
          }
          //.show-0-words {
          //  transform: translate(0,150px);
          //}
          //.show-1-words {
          //  transform: translate(0,-20px);
          //}
          //.show-2-words {
          //  transform: translate(0,-120px);
          //  p {
          //    margin-bottom: 10px;
          //    color: #7f7d7d;
          //  }
          //}
          //.show-3-words {
          //  transform: translate(0,-300px);
          //  p {
          //    margin-bottom: 15px;
          //  }
          //}
          .active {
            transition: all 500ms ease-in-out;
          }
          //.show-0-words.active {
          //  transform: translate(0,380px);
          //}
          //.show-1-words.active {
          //  transform: translate(0,150px);
          //}
          //.show-2-words.active {
          //  transform: translate(0,20px);
          //}
          //.show-3-words.active {
          //  transform: translate(0,-200px);
          //}
        }
      }
    }
  }
  .page5 {
    .sticky-wrapper::before{
      content: '';
      display: block;
      height: calc((var(--fade-distance) + var(--is-visible-distance) + var(--fade-distance)));
    }
    .sticky-inner {
      position: sticky;
      position: -webkit-sticky;
      bottom: 0;
      min-height: 100%;
      background-image: url("../../assets/image/intru4.jpg");
      .page5-txt {
        opacity: 0;
      }
      .page5-txt.active {
        opacity: 1;
        transition: all 1s ease;
      }
      .content {
        height: 100vh;
        box-sizing: border-box;
        position: relative;
      }
      .feature-wrapper {
        display: flex;
        flex-direction: row;
        >div {
          padding: 0 18px;
          color: #323232;
          font-size: 24px;
          text-align: center;
          display: flex;
          flex-direction: column;
          .title {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .intro {
            font-size: 15px;
            margin-top: 5px;
            flex: 0 0 auto;
          }
        }
        .has-border {
          border-right: 1px solid #D2B08C;
        }
      }
      .canvas-wrapper {
        position: absolute;
        bottom: 0;
        z-index: 1;
        max-height: 100%;
        width: 600px;
        will-change: transform;
        transform-origin: left center;
      }
    }
  }
}
@media screen and (max-width: 1441px),(-webkit-min-device-pixel-ratio: 1.1){
  .instrument-more {
    .page2 {
      .content {
        padding-top: 10%;
      }
      .canvas-wrapper {
        left: 60%
      }
    }
    .page5{
      .canvas-wrapper {
        margin-left: -100px;
      }
    }
  }
}
@media screen and (min-width: 1921px){
  .instrument-more {
    .page1 .content {
      padding-top: 27%;
    }
    .page4 {
      .sticky-inner {
        .inner-content {
          .screen-box {
            bottom: 6%;
            left: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/InstrumentMore.vue